import { useDispatch } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './portalsNotificationsCard.module.scss';
import PropertyData from '../../PendingEvents/PropertyData';
import AlertErrorsIndicator from './AlertErrorsIndicator';
import { showQuickDisplay } from '@/store/slices/components/quickDisplay/QuickDisplaySlice';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

function PropertyNotificationsCard({ property, trackCallback = null }) {
  const dispatch = useDispatch();
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const { location, address, property_picture_url, id, errors, alerts } =
    property;
  const propertyFileRedirect = () => {
    window.open(`${tokkoHost}/property/${id}`, '_blank');

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  const handleQDOpen = (event) => {
    event.stopPropagation();
    dispatch(showQuickDisplay({ id }));

    if (id && trackCallback) {
      trackCallback(TRACK_ELEMENT.PROPERTY_ADDRESS);
    }
  };

  return (
    <Box
      className={styles.propertyNotificationsCard}
      onClick={propertyFileRedirect}
    >
      <Box className={styles.leftContentContainer} onClick={handleQDOpen}>
        <PropertyData
          location={location}
          address={address}
          picture={property_picture_url}
        />
      </Box>
      <AlertErrorsIndicator errors={errors} alerts={alerts} />
    </Box>
  );
}

export default PropertyNotificationsCard;
